import React from "react";
import { useLang } from "@/context/LanguageContext";

const FOUNDER =
  "https://customer-assets.emergentagent.com/job_moroccan-ai-factory/artifacts/8sm5sh58_achrafpo.jpg";

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="py-16 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          <div className="md:col-span-5 relative">
            <div className="relative rounded-2xl overflow-hidden border border-sand-mid/40 aspect-[4/5] max-w-md group">
              {/* Photo with subtle, natural treatment */}
              <img
                src={FOUNDER}
                alt="Achraf AYACH — Founder of Moroccan AI Factory"
                className="absolute inset-0 w-full h-full object-cover transition duration-700 group-hover:scale-[1.02]"
                style={{
                  filter: "contrast(1.02) brightness(0.96) saturate(0.95)",
                }}
              />
              {/* Soft warm wash — barely there */}
              <div
                aria-hidden
                className="absolute inset-0 mix-blend-soft-light opacity-30 transition duration-700 group-hover:opacity-15"
                style={{
                  background:
                    "linear-gradient(160deg, rgba(212,111,77,0.5) 0%, rgba(217,185,155,0.2) 50%, rgba(26,26,30,0.3) 100%)",
                }}
              />
              {/* Subtle vignette */}
              <div
                aria-hidden
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(120% 90% at 50% 30%, transparent 60%, rgba(10,10,11,0.45) 100%)",
                }}
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0A0A0B] via-[#0A0A0B]/70 to-transparent h-2/5" />

              {/* Inner ring */}
              <div
                aria-hidden
                className="absolute inset-0 rounded-2xl pointer-events-none"
                style={{
                  boxShadow:
                    "inset 0 0 0 1px rgba(217,185,155,0.18), inset 0 -60px 60px -40px rgba(212,111,77,0.12)",
                }}
              />

              <div className="absolute bottom-5 left-5 right-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="h-1.5 w-6 rounded-full bg-terracotta" />
                  <span className="eyebrow text-[10px]">{t.about.eyebrow}</span>
                </div>
                <div className="font-display text-xl text-maif tracking-tight">
                  Achraf AYACH
                </div>
                <div className="text-xs text-maif-muted mt-0.5">{t.about.founder}</div>
                <div className="text-[11px] text-sand/80 mt-0.5">Software Engineer</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-7">
            <div className="eyebrow">{t.about.eyebrow}</div>
            <h2 className="mt-4 font-display font-light text-4xl md:text-5xl tracking-tight text-maif leading-tight">
              {t.about.title}
            </h2>
            <p className="mt-6 text-maif-muted text-base md:text-lg leading-relaxed max-w-xl">
              {t.about.body}
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6 max-w-xl">
              {t.about.stats.map((s, i) => (
                <div key={i} className="border-l border-sand-soft pl-4">
                  <div className="font-display text-xl text-maif">{s.v}</div>
                  <div className="eyebrow mt-1 text-[10px]">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
